import React from 'react';
import ComponentMap from '../ComponentMap';
import ConfigInputWrapper from './ConfigInputWrapper';
import StylingMap from '../../configured-layouts/StylingMap';
import disableInputIfReadOnly from './disableInputIfReadOnly';
import useShouldRender from './useShouldRender';
import Split from '../../../../split';
import useIsMobile from '../../../../hooks/useIsMobile';

export function FieldCreator({ fields, form, user, isEdit, item }) {
    return fields.map((field, index) => {
        const formField = form[field];

        const Component = ComponentMap[formField?.Component];

        if (!Component) return null;

        const { split: splitName } = formField;
        if (splitName && !Split.getBooleanTreatment(splitName)) return null;

        disableInputIfReadOnly(formField, isEdit);

        return (
            <ConfigInputWrapper key={`${formField.name}${index * 1}`} formField={formField} isEdit={isEdit}>
                <Component
                    {...formField}
                    user={user}
                    isEdit={isEdit}
                    item={item}
                    // wrap
                />
            </ConfigInputWrapper>
        );
    });
}

function FormCreator({ config, user, isEdit, label, item, layoutRefs }) {
    const isMobile = useIsMobile();
    const { form, form_layout } = config;
    return form_layout.map((section, index) => {
        const Component = StylingMap[section.Component];
        if (!Component) return null;

        const { split: splitName } = section;
        if (splitName && !Split.getBooleanTreatment(splitName)) return null;

        const shouldRenderCreateOption = !!section.conditionalCreateRender && !isEdit;
        const shouldRenderEditOption = !!section.conditionalEditRender && isEdit;
        let shouldRender = true;
        if (!!section.conditionalRender) {
            shouldRender = useShouldRender(section.conditionalRender, isEdit);
        } else if (shouldRenderCreateOption) {
            shouldRender = useShouldRender(section.conditionalCreateRender, isEdit);
        } else if (shouldRenderEditOption) {
            shouldRender = useShouldRender(section.conditionalEditRender, isEdit);
        }

        let sectionProps = isMobile && !!section.mobileProps ? section.mobileProps : section.props;
        if (label) {
            sectionProps = { ...sectionProps, label };
        }

        if (!shouldRender) return null;

        const { name } = section;
        return (
            <Component
                key={`${name}${index * 1}`}
                {...sectionProps}
                fieldCreatorProps={{ fields: section.fields, form, user, isEdit }}
                ref={(el) => {
                    // eslint-disable-next-line no-param-reassign
                    if (layoutRefs) layoutRefs.current[index] = el;
                }}
                data-index={index}
            >
                <FieldCreator
                    fields={section.fields}
                    form={form}
                    user={user}
                    isEdit={isEdit}
                    item={item}
                    // wrap
                />
            </Component>
        );
    });
}

export default FormCreator;
